import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  createVendor,
  deleteVendor,
  editVendor,
} from "../graphQL/graphMutation";
export const createVendorService = async (values) => {
  let createStatus = false;
  try {
    const res = await request(BASEURL, createVendor, {
      ...values,
    });
    createStatus = true;
  } catch (err) {
    console.error(err.message, "updateCustomerServive error");
    createStatus = false;
  }
  return createStatus;
};
export const updateVendorServive = async (values, id) => {
  let updateStatus = false;
  try {
    const res = await request(BASEURL, editVendor, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateCustomerServive error");
    updateStatus = false;
  }
  return updateStatus;
};

export const delteVendorService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteVendor, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "delteCustomerMutation error");
    delteStatus = false;
  }

  return delteStatus;
};
